export default __webpack_public_path__ + "static/media/DeliveryIcon.037fde4a.svg";